import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Callout } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_PRIORITY_PATH } from "../../ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";

interface PriorityShiftsCalloutProps {
  count: number;
}

export function PriorityShiftsCallout(props: PriorityShiftsCalloutProps) {
  const { count } = props;
  const history = useHistory();
  const { baseNavigationPath } = useShiftModalsDataContext();

  if (count <= 0) {
    return null;
  }

  return (
    <Callout
      aria-label="View Priority Shifts"
      title={`${count} Priority ${pluralize("Shift", count)}`}
      iconType="priority"
      sx={(theme) => ({
        backgroundColor: theme.palette.shift?.priority.background,
        color: theme.palette.shift?.priority.text,
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, { type: "priorityShifts", count });
        history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_PRIORITY_PATH}`);
      }}
    />
  );
}
